import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  OnDestroy,
  ElementRef,
  AfterViewInit
} from "@angular/core";
import {
  isBeta,
} from "../../shared/services";

import { ActivatedRoute, Params } from "@angular/router";
declare var $: any;
import swal from 'sweetalert2';
import Player from "@vimeo/player/dist/player.js";
import { ControllerService } from "../../shared/services/controller.service";
import { StoreHelper } from "../../shared/helpers/store.helper";
import { ReferencesService } from "../../references.service";

@Component({
    selector: "app-after-main-game",
    templateUrl: "./after-main-game.component.html",
    styleUrls: ["./after-main-game.component.scss"],
    standalone: false
})
export class AfterMainGameComponent implements OnInit , OnDestroy, AfterViewInit {

  @ViewChild('nextButton', { static: false }) nextButton: ElementRef;

  showReferencesFlag: boolean = false;
  current: number = 0;
  duration: number = 0;
  progressValue: number = 0;

  header: string = ""
  description: string = ""
  reference: string = ""

  underPlay: boolean = false
  OnCaption: boolean = false
  textToComplete: string = "Next"
  showNext: boolean = false

  isReplay: boolean = false

  skipToEnd: boolean = false
  player: any;

  video: string;
  title: string
  firstLoad: Boolean = false;
  skipVideos: Boolean = false;
  started: boolean = false;
  mouseInScreen: boolean = true;
  mediaFinished: boolean = false;

  lastUpdated: number = 0;
  updateInterval: number = 1000;
  lastEvent: number = 0;

  qpListener = null

  videos: any = {
    'history': '599667334',
    'language': '436773039',
    'language2': '480875660',
    'bridge': '444866036',
    'schools': '436779021',
    'education': '658525870',
    'potential': '783909838',
    'body-language': '480875660', // same as language2 but different copy.
  }
  activeNext: boolean = false

  isBeta: boolean = isBeta()

  constructor(private route: ActivatedRoute, public controller: ControllerService, private references:ReferencesService) {}

  ngOnDestroy(): void {
    this.qpListener.unsubscribe()
    $('.main-link').show()
  }

  ngAfterViewInit(): void {
    this.focusNext()
  }

  focusNext( ){

    if( this.showNext && this.activeNext){
       window.setTimeout( () => { this.nextButton.nativeElement.focus() }, 0)
    }
  }

  ngOnInit() {


    this.skipToEnd = StoreHelper.getObject('fastForward')

    this.qpListener = this.route.queryParams.subscribe((queryParams: Params) => {


      const videoComponent = this.controller.getSectionComponents()[0]

      if( videoComponent ){
        this.video = videoComponent.properties.vimeoId
        this.header = videoComponent.elements.find( (it) => it.type =="header").value
        this.description = videoComponent.elements.find( (it) => it.type == 'p').value
        this.reference = videoComponent.properties.reference

        this.isReplay = videoComponent.properties.isReplay == 'true' || this.controller.getPreviewing()

        this.showReferencesFlag = !!this.controller.getReferencePageForVideoId(this.video)
        this.showNext = this.isReplay && !this.controller.isLibrary()

      }else{
        alert("Error loading section, no video component specified.")
      }

      this.activeNext = this.isReplay

      if( this.isReplay ){
        window.setTimeout( () => {
          this.focusNext()
        },250)
      }


      $("body").removeClass();
      this.loadNewVideo(true);
      this.videobgEnlarge();

      this.player.disableTextTrack();

      $('#video-with-controls').on('fullscreenchange', function(){
        if( (window.document as any).fullscreenElement === null ){
          $("#vimeo_" + this.video).attr("height", "300px");
          this.underPlay = false;
          this.player.pause();
        }
      }.bind(this))
    });
  }

  onMediaTimeUpdate(data: { seconds: any; percent: any; duration: any }) {
    if (data.percent >= 0) {
      $("body").removeClass("loading");
    }
    this.mediaFinished = false;
    this.current = data.seconds;
    this.duration = data.duration;
    this.progressValue = data.percent * 100;
  }

  onClickProgress(e){
    const target = e.target
    const x = e.pageX - target.offsetLeft, clickedValue = x / target.clientWidth;

    if( clickedValue < target.clientWidth ){

      const newTime = Math.floor( clickedValue * this.current ) - 2;
      this.player.setCurrentTime( newTime );
      this.onMediaTimeUpdate( {seconds: newTime, duration : this.duration, percent: newTime/ this.duration })

    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.mediaFinished) {
      this.lastEvent = new Date().getTime();
      this.fadeInControls();
    }
  }

  @HostListener('document:click', ['$event'])
  onMouseClick(event: MouseEvent) {
    if (!this.mediaFinished) {
      this.lastEvent = new Date().getTime();
      this.fadeInControls();
    }
  }

  onMediaEnd() {

    this.mediaFinished = true;
    $("#vimeo_" + this.video).attr("height", "300px");

    $('.main-link').show()

    this.underPlay = false
    this.showNext = true

    this.activeNext = true

    window.document.exitFullscreen()

    if( !this.isReplay ){
        // in the event the progress fails, skip ahead so that at least they have option to try again without
        // replaying the video.
        this.controller.next(false, false, true)

    }else{
      this.focusNext()
    }

  }

  async onPlay() {

    this.started = true;
    $("#vimeo_" + this.video).attr("height", "100%");
    $(".play-next-wrapper").addClass("hide");
    this.underPlay = true;
    try{
      await this.player.play();
      this.videobgEnlarge();
      setTimeout(this.videobgEnlarge, 10);
      $('.main-link').hide()
      $('#video-with-controls')[0].requestFullscreen()
      if( this.skipToEnd ){
        this.player.setCurrentTime(this.duration - 2 );
      }
    }catch( exception ){
      // handle by displaying play button again.
      this.onPause()
    }

  }

  onPause() {
    $("#vimeo_" + this.video).attr("height", "300px");
    this.underPlay = false;
    this.player.pause();
    $('.main-link').show()
    window.document.exitFullscreen()
  }

  onBackward() {
    if (this.underPlay && this.current - 5 > 0) {
      this.current -= 5;
      this.player.setCurrentTime(this.current);
    }
  }

  onForward() {
    if (this.underPlay && (this.current + 5) < this.duration) {
      this.current += 5;
      this.player.setCurrentTime(this.current);
    }
  }


  OnSubtitles() {
    this.player.enableTextTrack('en');
    this.OnCaption = true;
  }

  OffSubtitles() {
    this.player.disableTextTrack();
    this.OnCaption = false;
  }

  onNext() {

    this.controller.next()

  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    let timeoutId;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(this.videobgEnlarge, 10);
  }

  videobgEnlarge() {
    let $videoBgAspect = $(".fullScreen .videobg-aspect");
    let $videoBgWidth = $(".fullScreen .videobg-width");
    let $controlContainer = $(".fullScreen .videobg-width .controls-container");
    let videoAspect =
      $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();
    let windowAspect = $(window).height() / $(window).width();
    let calculated = 100 * (videoAspect - (windowAspect - 0.06));
    $controlContainer.css("bottom", Math.max(calculated, 10) + "%");

    if (windowAspect > videoAspect && this.underPlay !== true) {
      let calcuationWith = (windowAspect / videoAspect) * 100;
      $videoBgWidth.width(calcuationWith + "%");
      if (calcuationWith > 100) {
        $controlContainer.css("width", 100 + "%");
        $videoBgWidth.width(100 + "%");
      }
    } else {
      if (this.underPlay) {
        $videoBgWidth.width(100 + "%");
      }
    }
 }

  fadeOutControls() {
    if (parseInt($(".controls-container").css("opacity"), 10) !== 0) {
      $(".controls-container").css("opacity", 0);
    }
  }

  fadeInControls() {
    if (parseInt($(".controls-container").css("opacity"), 10) !== 1) {
      $(".controls-container").css("opacity", 1);
    }
  }

  checkControls(event) {
    if (event.key === 'Tab') {
      this.fadeInControls();
    }
  }


  private loadNewVideo(firstLoad = false) {
    this.firstLoad = firstLoad;
    this.lastEvent = new Date().getTime();
    $("body").addClass("loading");

    let content = $(
      '<iframe id="vimeo_' +
        this.video +
        '" src="https://player.vimeo.com/video/' +
        this.video +
        '?api=1&controls=0&mute=0&loop=0&autoplay=0&playsinline=0" style="visibility:hidden;" onload="this.style.visibility = \'visible\';" width="100%" height="300px;" frameborder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" allowTransparency="true" allow="autoplay"></iframe>'
    );
    $(".videobg-hide-controls").html(content);
    let obj = this;
    this.player = new Player($("#vimeo_" + this.video));
    this.player.setVolume(1);
    this.player.on("timeupdate", function(data) {
      $("body").removeClass("loading");
      if (obj.lastEvent && obj.lastEvent < new Date().getTime() - 5000) {
        obj.lastEvent = new Date().getTime();
        obj.fadeOutControls();
      }
      if (!obj.lastUpdated || obj.lastUpdated + obj.updateInterval < Date.now()) {
        data.duration = obj.duration;
        obj.lastUpdated = Date.now()
        obj.onMediaTimeUpdate(data);
      }
    });
    this.player.on("loaded", function(data) {
      $("body").removeClass("loading");
      obj.player
        .getDuration()
        .then(function(duration) {
          obj.onMediaTimeUpdate({ seconds: 0, percent: 0, duration: duration });
        })
        .catch(function(error) {
          // an error occurred
        });
    });
    this.player.on("ended", function(data) {
      obj.current = obj.duration;
      obj.onMediaEnd();
    });
  }

  showReferences() {
    this.references.showReferences(this.video)
  }
}

